import React from 'react';
interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  srOnlyLabel?: boolean;
}
export function Toggle({
  checked,
  onChange,
  label,
  srOnlyLabel
}: ToggleProps) {
  return <label className="inline-flex cursor-pointer items-center gap-3" data-id="element-898" data-mp="17wluvbyaggww">
      <button type="button" role="switch" aria-checked={checked} aria-label={srOnlyLabel ? label : undefined} onClick={() => onChange(!checked)} className={`relative inline-flex h-6 w-11 shrink-0 rounded-full transition-colors focus:outline-none focus-visible:ring-4 focus-visible:ring-azure/30 ${checked ? 'bg-azure' : 'bg-slate-200'}`} data-id="element-899" data-mp="1cvys8qmsd6dq">
        <span className={`absolute top-0.5 h-5 w-5 rounded-full bg-white shadow transition-transform ${checked ? 'translate-x-[22px]' : 'translate-x-0.5'}`} data-id="element-900" data-mp="t9iyx9pm6gbo" />
      </button>
      {!srOnlyLabel && <span className="text-sm text-slate-700" data-id="element-901" data-mp="k6hst90r0p80">{label}</span>}
    </label>;
}